import React from 'react'
import classNames from 'classnames'
import Review from '#src/components/Reviews/StarReviewWidget'
import ShareFooter from '#src/components/Share/Footer'
import { ExpertFooterUserReviewsComponent } from '#src/generated/graphql'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import styles from './styles.css'
import { FullBlockLoader, CircleLoader, Grid, GridItem } from '@deal/components'

interface ExpertFooterBlockProps {
  children: React.ReactNode
  title: React.ReactNode
  content: string
  actionLabel: string
}

const ExpertFooterBlock: React.SFC<ExpertFooterBlockProps> = ({
  title,
  content,
  actionLabel,
  children
}) => (
  <div className={styles.block}>
    <div className={styles.blockTitle}>{title}</div>
    <div className={styles.blockContent}>{content}</div>
    {children}
    <div className={styles.blockActionLabel}>{actionLabel}</div>
  </div>
)

interface ExpertFooterProps {
  businessUserId: string
  className?: string
  businessUserVanityId?: string | null
  businessUserName?: string | null
  colorIcons?: boolean
  hideReview?: boolean
}

const ExpertFooter: React.SFC<ExpertFooterProps & WithIdentityProps> = ({
  myself,
  hideReview,
  className,
  businessUserName,
  businessUserId,
  businessUserVanityId
}) => {
  if (!myself) {
    return null
  }

  return (
    <div className={classNames(styles.footer, className)}>
      <Grid>
        <GridItem col={2}>
          <div className={styles.container}>
            <ExpertFooterBlock
              title="Spread the love"
              content={`Invite friends to shop ${businessUserName &&
                `with ${businessUserName}`}. Get $25 for every friend that purchases and they get $25 too!`}
              actionLabel="Select a way to share"
            >
              <ShareFooter
                type="expert"
                variant="responsive"
                sharePath={`/experts/${
                  businessUserVanityId ? businessUserVanityId : businessUserId
                }`}
                expertId={businessUserId}
                utmContent={businessUserVanityId ? businessUserVanityId : businessUserId}
              />
            </ExpertFooterBlock>
            {!hideReview && (
              <ExpertFooterUserReviewsComponent
                variables={{
                  userId: myself.user.id,
                  expertId: businessUserId
                }}
              >
                {({ data, loading }) => {
                  if (loading) {
                    return <FullBlockLoader loader={CircleLoader} />
                  } else if (data && data.user) {
                    const matchingExpertReview = data.user.consumerExpertReviewConnection.edges.find(
                      expertReviewEdge => expertReviewEdge.node.expert.id === businessUserId
                    )

                    if (!matchingExpertReview) {
                      return (
                        <>
                          <div className={styles.division} />
                          <ExpertFooterBlock
                            title={
                              <>
                                How's it going
                                {businessUserName ? (
                                  <>
                                    {' '}
                                    with <span className={styles.name}>{businessUserName}</span>
                                  </>
                                ) : null}
                                ?
                              </>
                            }
                            content="A quick rating below helps us continue to improve. All feedback about your expert is appreciated!"
                            actionLabel="Select your rating "
                          >
                            <Review expertId={businessUserId} largeIcons invertedIcons />
                          </ExpertFooterBlock>
                        </>
                      )
                    }
                  }

                  return null
                }}
              </ExpertFooterUserReviewsComponent>
            )}
          </div>
        </GridItem>
      </Grid>
    </div>
  )
}

export default withIdentity(ExpertFooter)
